<mat-tab-group
  [selectedIndex]="selectedTabIndex"
  (selectedTabChange)="onTabChange($event.index)"
  mat-stretch-tabs
  mat-align-tabs="center"
>

  <mat-tab label="General" i18n-label="@@general"></mat-tab>
  <mat-tab label="Training materials" i18n-label="@@trainingMaterials"></mat-tab>
  <mat-tab label="Marketing materials" i18n-label="@@marketingMaterials"></mat-tab>
  <mat-tab label="Competitors" i18n-label="@@competitors"></mat-tab>
  <mat-tab label="References" i18n-label="@@references"></mat-tab>
  <mat-tab label="Value proposal" i18n-label="@@valueProposal"></mat-tab>

  <mat-tab
    *ngIf="isManufacturer()"
    label="Subscriptions"
    i18n-label="@@subscriptions"
  ></mat-tab>

</mat-tab-group>

<router-outlet></router-outlet>